import { Checkbox } from '@liveauctioneers/hammer-ui-core/checkbox';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, H5, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

type HousesToExcludeData = {
    auctionHouseName: string;
    selected?: boolean;
    sellerId: string;
    totalResults: number;
};

type HousesToExcludeTableProps = {
    className?: string;
    houseData: HousesToExcludeData[];
    onSelectHouse: (sellerId: string) => void;
};

export const HousesToExcludeTable = ({ className, houseData, onSelectHouse }: HousesToExcludeTableProps) => {
    return (
        <>
            <H5 className="mb-xs">
                <FormattedMessage id="excludeAuctionHousesFilter.modal.housesToExcludeTable.title" />:
            </H5>
            <div className={cn('overflow-hidden rounded-md border border-border-secondary', className)}>
                {/* Header */}
                <div className="flex items-center border-b border-border-primary px-sm py-2xs">
                    <div className="w-[42px] flex-shrink-0" />
                    <LabelStrong className="flex-1">
                        <FormattedMessage id="excludeAuctionHousesFilter.modal.housesToExcludeTable.auctionHouse" />
                    </LabelStrong>
                    <LabelStrong className="ml-auto">
                        <FormattedMessage id="excludeAuctionHousesFilter.modal.housesToExcludeTable.totalResults" />
                    </LabelStrong>
                </div>
                {/* Body */}
                <div className="max-h-[337px] overflow-y-auto [-ms-overflow-style:none] [scrollbar-width:none] hover:[&::-webkit-scrollbar-thumb]:bg-border-secondary [&::-webkit-scrollbar]:w-0 hover:[&::-webkit-scrollbar]:w-2">
                    {houseData.map((item) => {
                        const isSelected = item.selected || false;
                        return (
                            <div
                                className={cn(
                                    'flex items-center border-b border-border-secondary px-sm py-xs last:border-b-0 hover:bg-background-secondary',
                                    isSelected && 'bg-background-secondary'
                                )}
                                key={item.sellerId}
                            >
                                <div className="w-[42px] flex-shrink-0">
                                    <Checkbox.Option
                                        checked={isSelected}
                                        onChange={() => onSelectHouse(item.sellerId || '')}
                                    />
                                </div>
                                <BodySecondary className="max-w-[240px] flex-1 truncate">
                                    {item.auctionHouseName}
                                </BodySecondary>
                                <BodySecondary className="ml-auto">{item.totalResults}</BodySecondary>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};
